import { Component, AfterViewInit } from '@angular/core';
import * as Prism from 'prismjs';
import { FilterNroListaDom, Empresa, ValidDominio, Viaje } from '@models';
import { ViajeService, ParametricasService } from '@services';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { CoreFacade } from '@core/core.facade';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css'],
})
export class HomeComponent implements AfterViewInit {
	public domFindData: boolean;
	public buscando: boolean;
	public esDominio: boolean;
	public errorBusqueda: string;
	public empresa: Empresa = new Empresa();
	public filtro: FilterNroListaDom = new FilterNroListaDom();
	public flagViajeExiste: boolean;
	public validDom: ValidDominio = new ValidDominio();
	public viaje: Viaje = new Viaje();
	private dut: any;
	public serverTime: any;
	vigente: boolean;
	public hoy: any;
	activeIndex: any = [];
	public ultimosViajes: Array<Viaje> = [];

	constructor(
		private _viajeService: ViajeService,
		private _activatedRoute: ActivatedRoute,
		private _parametricasService: ParametricasService,
		public coreFacade: CoreFacade
	) {
		this.setIni();
	}

	setIni() {
		this.buscando = false;
		this.domFindData = true;
		this.errorBusqueda = '';
		this.flagViajeExiste = true;
		this.dut = this._activatedRoute.snapshot.queryParams['dut'];
		this.vigente = false;
		this.hoy = moment()
			.utc(true)
			.format('DD-MM-YYYY');
		this._activatedRoute.queryParamMap.subscribe(routeParams => {
			this.dut = routeParams.get('dut');
			this.filtro.nroListaDominio = this.dut;
			this.filtro.verify = routeParams.get('verify');
			this.buscando = false;
			this.domFindData = true;
			this.errorBusqueda = '';
			this.flagViajeExiste = true;
			this.vigente = false;
			this.hoy = moment()
				.utc(true)
				.format('DD-MM-YYYY');
			this.buscarDut();
		});
	}

	/**
	 * @method ngAfterViewInit
	 */
	ngAfterViewInit() {
		Prism.highlightAll();
	}

	buscarDut() {
		// Define si el parametro es id o dominio
		const regexp = /^\d+(\.\d{1,2})?$/;
		this.validDom = new ValidDominio();
		this.vigente = false;
		if (this.filtro.nroListaDominio && this.filtro.nroListaDominio.trim() !== '') {
			this.viaje = new Viaje();
			/* Flag Busqueda */
			this.buscando = true;

			this.esDominio = !regexp.test(this.filtro.nroListaDominio);
			const llamado = this.esDominio
				? this._viajeService.getViajeConsultaGeneralByDominio(this.filtro.nroListaDominio.trim())
				: this._viajeService.getViajeConsultaGeneralById(
						this.filtro.nroListaDominio.trim(),
						this.filtro.verify
				  );

			llamado.subscribe(response => {
				this.buscando = false;
				if (response.result === 'ok') {
					/* Flag Busqueda */
					this.flagViajeExiste = true;
					if (response.data && (response.data.id || (response.data[0] && response.data[0].id))) {
						this.viaje = response.data.id ? new Viaje(response.data) : new Viaje(response.data[0]);
						if (response.data[0]) {
							this.ultimosViajes = [];
							this.viaje = new Viaje(response.data[0]);
							response.data.forEach(element => {
								if (this.viaje.id !== element.id) {
									this.ultimosViajes.push(new Viaje(element));
								}
							});
						} else {
							this.ultimosViajes = [];
						}

						/* CHECK FECHAS */
						this._parametricasService.getServerDateTime().subscribe(resp => {
							if (resp.result === 'ok') {
								this.serverTime = new Date(
									moment(resp.data)
										.utc(true)
										.format('YYYY-MM-DD[T]HH:mm:ss')
								);
								if (this.viaje.fechaFin > this.serverTime) {
									this.vigente = true;
								}
							}
						});

						if (this.viaje.cnrtNro) {
							this._viajeService.getEmpresaInfo(this.viaje.cnrtNro).subscribe(resp => {
								if (resp.data) {
									this.empresa = resp.data;
								}
							});
						}

						if (this.viaje.choferes.length > 0) {
							this.viaje.choferes.forEach((element, index) => {
								this.activeIndex.push(index);
							});
						}
					} else {
						this.flagViajeExiste = false;
						this.errorBusqueda = response.userMessage;
					}
				}
			});
			if (this.esDominio) {
				this._viajeService.getValidaDominio(this.filtro.nroListaDominio).subscribe(resp => {
					this.domFindData = false;
					if (resp.data) {
						this.validDom = new ValidDominio(resp.data);
						this.validDom.find = true;
					}
				});
			}
		}
	}
}
